import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Navigation from '../components/Navigation';
import { transfer } from '../actions/accountActions';

const TransferPage: React.FC = () => {
  const accountsList = useSelector((state: appState) => state.accountsList);
  const { accounts, tsuccess, error } = accountsList;

  const [amount, setAmount] = useState('1.00');
  const [numOne, setNumOne] = useState(accounts[0].number);
  const [numTwo, setNumTwo] = useState(accounts[0].number);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const userLogin = useSelector((state: appState) => state.userLogin);
  const { userData } = userLogin;

  useEffect(() => {
    if (!userData) {
      navigate('/');
    }
  }, [navigate, userData]);

  const lastFour = (str: string) => {
    return str.slice(-4);
  };

  const cancelHandler = () => {
    navigate('/account');
  };

  const submitHandler = (e: React.FormEvent) => {
    e.preventDefault();

    const numAmount = parseFloat(amount).toFixed(2);

    const transferAmount = parseFloat(numAmount);

    dispatch(transfer(numOne, numTwo, transferAmount));

    setTimeout(() => {
      navigate('/account');
    }, 2000);
  };

  return (
    <div className='account-page'>
      <Navigation />
      <form className='transaction-form' onSubmit={submitHandler}>
        <p>Select account to transfer from: </p>
        <select
          name='transfer-from'
          id='transfer-from'
          className='transaction-select'
          onChange={(e) => setNumOne(e.target.value)}
        >
          {accounts.map((account) => (
            <option key={account.id} value={account.number}>
              {account.type} {lastFour(account.number)}
            </option>
          ))}
        </select>
        <p>Select account to transfer to: </p>
        <select
          name='transfer-to'
          id='transfer-to'
          className='transaction-select'
          onChange={(e) => setNumTwo(e.target.value)}
        >
          {accounts.map((account) => (
            <option key={account.id} value={account.number}>
              {account.type} {lastFour(account.number)}
            </option>
          ))}
        </select>
        <label htmlFor='transfer-amount'>Transfer Amount ($):</label>
        <input
          type='number'
          name='transfer-amount'
          id='transfer-amount'
          className='transaction-input'
          min='0.01'
          step='0.01'
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
        />
        <div className='transaction-buttons'>
          <button className='cancel-btn' onClick={cancelHandler}>
            Cancel
          </button>
          <button type='submit' className='submit-btn transfer-btn'>
            Transfer
          </button>
        </div>
        {tsuccess && (
          <p className='t-success'>Your transfer has been made successfully!</p>
        )}
        {error && <p className='t-error'>{error}</p>}
      </form>
    </div>
  );
};

export default TransferPage;
